import React from 'react';
import NamePlate from '../name-plate/NamePlate';
import Badge from '../badge/Badge';

const Header = () => {
    return (
        <header className="row">
            <Badge />
            <NamePlate />
        </header>
    );
};

export default Header;
